import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import Bundle from '@saucelabs/sl-component-bundle';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';
import { SentryBoundary } from '@saucelabs/sl-component-sentry';
import { constants as sentryConstants } from '@saucelabs/sl-util-sentry';

import teamManagementReducer from './reducers';
import GroupsEnabledContainer from './containers/GroupsEnabledContainer';
import OrgAdminContainer from './containers/OrgAdminContainer';

const importTMContainer = () => import(/* webpackChunkName: "tm-container" */ './containers/TeamManagementContainer');
const importGroupDetails = () => import(/* webpackChunkName: "tm-group-details" */ './group-details/containers/GroupDetailsContainer');
const importTeamDetails = () => import(/* webpackChunkName: "tm-team-details" */ './team-details/containers/TeamDetailsContainer');
const importUserDetails = () => import(/* webpackChunkName: "tm-user-details" */ './user-details/containers/UserDetailsContainer');
const importSettings = () => import(/* webpackChunkName: "tm-settings" */ './containers/SettingsContainer');

const TeamManagementRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <SentryBoundary owner={sentryConstants.TEAMS.IAM}>
      <Switch>
        <Redirect
          exact
          from={`${match.url}/teams/:teamId`}
          to={`${match.url}/teams/:teamId/members`}
        />
        <Redirect
          exact
          from={`${match.url}/lines-of-business/:groupId`}
          to={`${match.url}/lines-of-business/:groupId/teams`}
        />
        <OrgAdminContainer>
          {/* Team Admin */}
          <Switch>
            <BundleRoute
              load={importTeamDetails}
              path={`${match.url}/teams/:teamId/:tabName`}
            />
            <BundleRoute
              load={importUserDetails}
              path={`${match.url}/users/:id`}
            />
          </Switch>
          {/* Org Admin */}
          <Switch>
            <BundleRoute
              load={importSettings}
              path={`${match.url}/settings/:tabName?`}
            />
            <BundleRoute
              load={importTeamDetails}
              path={`${match.url}/teams/:teamId/:tabName`}
            />
            <Route
              path={`${match.url}/lines-of-business/:groupId/:tabName`}
              render={(props) => (
                <GroupsEnabledContainer>
                  <Bundle load={importGroupDetails}>
                    {(Component) => <Component {...props} />}
                  </Bundle>
                </GroupsEnabledContainer>
              )}
            />
            <BundleRoute
              load={importUserDetails}
              path={`${match.url}/users/:id`}
            />
            <BundleRoute
              load={importTMContainer}
              path={`${match.url}/:tabName?`}
            />
          </Switch>
        </OrgAdminContainer>
      </Switch>
    </SentryBoundary>
  </LoginRequiredContainer>
);

TeamManagementRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};


export default dynamic(
  'apps.teamManagement', attachReducer(teamManagementReducer),
)(TeamManagementRoutes);
